import React, { useState, useEffect } from "react";
import { getStyle } from "../../../styles/styles";
import { getAllRates } from "../../../networking/NetworkingRates";
import { Table } from "antd";

var style = getStyle();

const AllRates = () => {
    //const { columnsData, columnDetail, refreshTrigger } = useAllRatesData('','');
    const [rates, setRates]           = useState([]);

    useEffect(() => {
        const loadRates = async () => {
            const json = await getAllRates(0,0);
            if (json != null && json.result != null) {
                const rates = json.result.map((c, index) => ({ ...c, key: index + 1 }));
                setRates(rates);
            } else {
                setRates([]);
            }
        };
        loadRates();
    });

    const columns = [
        {
            title: 'Base ccy',
            dataIndex: 'Base Currency',
            width: '17.5%',
            editable: true,
            align: 'center',
            sorter          : (a, b) => { return a['Base Currency'].localeCompare(b['Base Currency'])},
            sortDirections  : ['descend', 'ascend'],
            //...getColumnSearchProps('Base Currency'),
        },
        {
            title: 'Foreign ccy',
            dataIndex: 'Quoted Currency',
            width: '17.5%',
            editable: true,
            align: 'center',
            sorter          : (a, b) => { return a['Quoted Currency'].localeCompare(b['Quoted Currency'])},
            sortDirections  : ['descend', 'ascend'],
            //...getColumnSearchProps('Quoted Currency'),
        },
        {
            title: 'BID',
            dataIndex: 'BID',
            width: '17.5%',
            editable: true,
            align: 'center',
            sorter          : (a, b) => { return a['BID'].localeCompare(b['BID'])},
            sortDirections  : ['descend', 'ascend'],
            //...getColumnSearchProps('BID'),
        },
        {
            title           : 'ASK',
            dataIndex       : 'ASK',
            width           : '17.5%',
            editable        : true,
            align           : 'center',
            sorter          : (a, b) => a['ASK'] - b['ASK'],
            sortDirections  : ['descend', 'ascend'],
           //...getColumnSearchProps('ASK'),
        }
    ]

    return(
        <div style={{
                width: 'auto',
                height: '80%',
                flexDirection: 'column',
                padding: 10,
                display: 'flex',
                alignItems: 'stretch',
                Margin:'0 auto'}}>
            <div 
                className ='title-widget'
                style={{
                    display         : 'block',
                    textAlign       : 'center'
                }}>
                    <span>Rates</span>
            </div>
            {Array.isArray(rates) && rates.length > 0 ? (
                <div>
                    <Table
                        dataSource={rates}
                        columns={columns}
                        size="small"
                    />
                </div>
            ) : (
                <div style={{ textAlign: 'center', marginTop: '40px', color: '#888' }}>No data to display</div>
            )}
        </div>
    )
};

export default AllRates;